module.exports = __webpack_public_path__ + "media/images/investor-micro-ventures-fd6630cf.png";